import React, { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Navbar, Container, Offcanvas } from "react-bootstrap";
import Footer from "../Footer/Footer";
import NavLinks from "./NavLinks";
import "./Navbar.css";

function NavBar() {
  const [show, setShow] = useState(false);

  return (
    <>
        <Navbar bg="dark" variant="dark" fixed="top" className="nav-size">
      <Container>
        <NavLink to="/" className="title text-white fw-bold text-uppercase">
          Interviews
        </NavLink>

        <button className="toggle bg-white border-0 rounded-2 d-xl-none" onClick={() => setShow(true)}>
          ☰
        </button>

        <div className="d-none d-xl-flex">
          <NavLinks />
        </div>

        <Offcanvas
          show={show}
          onHide={() => setShow(false)}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Interviews</Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body className="bg-dark">
            <NavLinks closeMenu={() => setShow(false)} />
            <Footer />
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
        </Navbar>

      <Outlet />
    </>
  );
}

export default NavBar;
